import React from 'react';
import useEsiPortal from '../../hooks/useEsiPortal';

export default function PriceMatch() {
  const esiPortalRef = useEsiPortal('esi-price-match');

  return <div ref={esiPortalRef} data-testid="price-match" />;
}
